export default __webpack_public_path__ + "static/media/Volume.69939a84.svg";